module.exports = __webpack_public_path__ + "static/media/drywall.17850bf1.svg";